import { SurveyCreatorComponent, SurveyCreator } from "survey-creator-react";
import "survey-core/defaultV2.min.css";
import "survey-creator-core/survey-creator-core.min.css";
import Alert from 'react-bootstrap/Alert';
import "survey-core/defaultV2.css";
import "survey-creator-core/survey-creator-core.css";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import { general,hotel,customer } from "../home/initial";
import { useParams } from "react-router-dom";
import React, { useState } from 'react';
import Toast from 'react-bootstrap/Toast';
import Modal from 'react-bootstrap/Modal';

import { axiosInstance } from "../axios/Axios";


const creatorOptions = {
    questionTypes: ["text", "checkbox", "radiogroup", "range","rating","comment"],
  showLogicTab: false,
  showJSONEditorTab :false,
  showEmbeddedSurveyTab:false,
  isAutoSave: true,
};


export default function Editor() {

    const { gid } = useParams();

    const [showToast, setShowToast] = useState(false);
    const toggleShowToast = () => setShowToast(!showToast);

    const [msg, setMsg] = useState(null);
    const [subMsg, setSubMsg] = useState(null);

    const [showModal, setShowModal] = useState(false);

    const handleCloseModal = () => setShowModal(false);
    const handleShowModal = () => setShowModal(true);

    const [data, setData] = useState(null);
    
    useEffect(() => {

        axiosInstance.get('survey/get/'+gid+'/')
              .then((res) => {
                    setData(res.data)
                    if("format" in res.data)
                    {
                        window.localStorage.setItem("edit-survey-json",JSON.stringify(res.data.format)); 
                    }
                    
              })

        var footbar = document.getElementsByClassName("svc-creator__banner")
        if (footbar.length >0)
        {
            footbar[0].style.display='None';
        }
    },[])

    const navigate = useNavigate();    
    const creator = new SurveyCreator(creatorOptions);

    creator.onShowingProperty.add(function(sender, options){
        if(options.obj.getType() == "survey") {
            options.canShow = options.property.name == "title";
        }
    });
  
    if(data===null)
        return <div>Loading</div>

    if("msg" in data && data["msg"]==="error occured")
        return <div>Error</div>

    creator.text = window.localStorage.getItem("edit-survey-json");

  creator.saveSurveyFunc = (saveNo, callback) => { 
    window.localStorage.setItem("edit-survey-json", creator.text);
    callback(saveNo, true);
  };
  
  return (
    <>
        <Alert  variant="danger">
            Editing the form leads to deleting previously saved responses
        </Alert>

        <SurveyCreatorComponent creator={creator} />
        
        <div style={{
              position:"fixed",
              bottom:"50px",
              right:"50px",
              width:"100%",
          }} 
        >
          <div id="create_display_msg" 
          style={{
            display:"inline-block",
          }}>
            <Toast show={showToast} onClose={toggleShowToast}>
              <Toast.Header>
                <strong className="me-auto">{msg}</strong>
              </Toast.Header>
              <Toast.Body>{subMsg}</Toast.Body>
            </Toast>
          </div>
          <Button style={{
                display:"inline-block",
                float:"right",
                padding:"10px 20px",
                borderRadius:"5px"
            }} 
            id="create_save_btn"
            variant="primary"
            onClick={handleShowModal}
          >
            Update
          </Button>
        </div>

        <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Update Changes</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            Updating Modal, leads to deleting existing data
            <p>Think twice before updating</p>
        </Modal.Body>
        
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Don't Update
          </Button>
          <Button variant="primary" onClick={()=>{
                handleCloseModal()
                var str = localStorage.getItem("edit-survey-json")
                var json = JSON.parse(str)
                axiosInstance.post('survey/edit/'+gid+'/',json)
                .then((res) => {
                    var msg = res.data['msg']
                    console.log(msg)
                    if(msg==="success")
                    {
                    setMsg("Successful");
                    setSubMsg("Survey format updated successfully");
                    // window.location.reload()
                    }
                    else if(msg==="No title")
                    {
                    // show a toast to change title
                    setMsg("Error");
                    setSubMsg("Enter title, Dont leave it empty");
                    }
                    else if(msg==="Change title")
                    {
                    // show a toast to change title
                    setMsg("Error");
                    setSubMsg("Title Name already exits, Change it");
                    }
                    else{
                    // show  toast as error
                    setMsg("Error");
                    setSubMsg("Try Again, Updating")
                    
                    }
                })
                .then((res)=>{
                    toggleShowToast();
                })
                }}>
            Update
          </Button>
        </Modal.Footer>
      </Modal>

    </>
  )
}


